import React from 'react';
import Header4 from '../../components/header/header4/Header4';

import HeroTestimonialSection from '../../components/hero_section_testimonial/HeroTestimonialSection';
import ImagesGalleryTestimonial from '../../components/images_gallery_testimonial/ImagesGalleryTestimonial';
import ProjectDoneSection from '../../components/project_done_section/ProjectDoneSection';
import ClientsLogoTestimonials from '../../components/clients_logo_testimonials/ClientsLogoTestimonials';
import TestimonialSection2 from '../../components/testimonials_section/testimonialsection_2/TestimonialSection2';
import VideoGallery from '../../components/video_gallery_section/VideoGallery';
import Footer from '../../components/footer/Footer';
export default function Testimonials() {
  return (
    <>
    <Header4/>
    <HeroTestimonialSection/>
    <ImagesGalleryTestimonial/>
    <ProjectDoneSection/>
    <ClientsLogoTestimonials/>
    <TestimonialSection2/>
    <VideoGallery/>
    <Footer/>
    </>







  )
}
